import { ReactComponent as CalendarBlank } from 'assets/icons/CalendarBlank.svg';
import { ReactComponent as Clock } from 'assets/icons/Clock.svg';
import Tag from 'components/Tag';
import ROUTES from 'constants/routes';
import { getFormatedDate, getImageUrl, getTextContent } from 'helpers';
import React from 'react';
import { Link } from 'react-router-dom';

const PostItem = ({ data }) => {
    const { title, time_to_read, createdAt, image, tags, contents, slug } = data?.attributes;
    const src = getImageUrl(image);
    const created = getFormatedDate(createdAt);

    const descriptionItem = contents?.find(item => item.__component === 'componetns.rich-editor')?.content?.find(item => item.type === 'paragraph');
    const description = descriptionItem ? [descriptionItem] : [];

    return (
        <li className='blog-post-item__li'>
            <Link to={`${ROUTES.blog}/${slug}`} className="blog-post-item">
                <div className="blog-post-item__image">
                    <img src={src} alt="" />
                </div>
                <div className="blog-post-item__body">
                    <div className="blog-post-item__body-tags">
                        {tags?.data?.map(item => (
                            <Tag key={item.id} text={item?.attributes?.name} />
                        ))}
                    </div>
                    <div>
                        <div className="description2">{title}</div>
                        {/* //TO DO FIX INNER CLASS IN DESCRIPTION */}
                        <div className="body2 blog-post-item__body-desc">{getTextContent(description)}</div>
                    </div>
                    <div className="blog-post-item__body-info">
                        <div className="blog-post-item__body-info-item">
                            <CalendarBlank />
                            {created}
                        </div>
                        <div className="blog-post-item__body-info-item">
                            <Clock />
                            {time_to_read}
                        </div>
                    </div>
                </div>
            </Link>
        </li>
    );
};

export default PostItem;